import { useCallback } from 'react';

import { useRouter } from '../router/useRouter';

const useShopRoutes = () => {
  const { useNavigate, basePath, useLocation } = useRouter();
  const navigate = useNavigate();

  const location = useLocation();

  const navigateToCheckout = useCallback(
    (checkoutId: string) => {
      navigate(location.pathname.toLocaleLowerCase(), {
        replace: true,
        state: {
          shopBackgroundLocation: {
            ...location,
            pathname: `${basePath || ''}/shop/carts/checkout/${checkoutId}`,
          },
        },
      });
    },
    [location, navigate, basePath]
  );

  const closeCheckoutRoute = useCallback(() => {
    navigate(location.pathname, {
      replace: true,
      state: {},
    });
  }, [location.pathname, navigate]);

  return {
    closeCheckoutRoute,
    navigateToCheckout,
  };
};

export { useShopRoutes };
